import React from 'react'
import {Box, Text, useStyleConfig} from '@chakra-ui/react'

import PropTypes from 'prop-types'
import ProductCompareGrid from '../../../components/product-compare/partials/product-compare-grid'

const CompareTable = ({
    dataToDisplay,
    categoryLabel,
    numOfProducts,
    visibleColumns,
    gridGap,
    hideIdenticalRows = false,
}) => {
    const styles = useStyleConfig('ProductComparePlp')

    return (
        <Box overflowX="auto" w="100%" bg="background.base.default">
            <Box {...styles.compareTableHeader}>
                <Text {...styles.compareTableHeaderLabel}>{categoryLabel}</Text>
            </Box>
            <ProductCompareGrid
                gridData={dataToDisplay}
                numOfProducts={numOfProducts}
                visibleColumns={visibleColumns}
                colorlessHeaders
                hideIdenticalRows={hideIdenticalRows}
                gridProps={{gap: gridGap}}
            />
        </Box>
    )
}

CompareTable.propTypes = {
    dataToDisplay: PropTypes.array,
    categoryLabel: PropTypes.string,
    numOfProducts: PropTypes.number,
    visibleColumns: PropTypes.arrayOf(PropTypes.bool),
    gridGap: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    hideIdenticalRows: PropTypes.bool,
}

export default CompareTable
